import { base44 } from '@/api/base44Client';

/**
 * Punto único de medición de conversiones del sitio.
 *
 * Todos los eventos se envían como eventos propios de la plataforma, que es la
 * fuente que leen los objetivos del plan de marketing (conteo por nombre de
 * evento en una ventana de 7 días). No dependen de Google Tag Manager.
 */
export function trackEvent(eventName, properties = {}) {
  base44.analytics?.track?.({ eventName, properties });
}

/** Intención de demo: se dispara al pulsar un CTA que lleva a /demo. */
export function trackDemoIntent({ from, button }) {
  trackEvent('click_to_demo', {
    from: from || '/',
    button: button || 'unknown',
  });
}

/**
 * Lead captado. Punto común para cualquier vía de captación presente o futura:
 * la página que llama solo aporta el origen y los datos de la solicitud.
 */
export function trackLead(properties = {}) {
  trackEvent('lead', properties);
}

let initialRouteSeen = false;

/**
 * Avisa a Analytics de cada cambio de ruta: la web es una single page app, así
 * que sin esto solo se mide la primera página visitada.
 *
 * La primera ruta se omite porque el contenedor de etiquetas ya envía la página
 * vista inicial. Si ese contenedor tuviera su propio disparador de cambio de
 * historial, basta con quitar la llamada a gtag de abajo.
 */
export function trackPageView(path) {
  if (typeof window === 'undefined') return;
  if (!initialRouteSeen) {
    initialRouteSeen = true;
    return;
  }
  if (!window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
    page_location: `${window.location.origin}${path}`,
  });
}